import { BULK_ACTIONS } from '../../../constants/actionTypes';
// eslint-disable-next-line import/no-cycle
import { dataFetch } from './data';
import { ui } from '../../../constants/config';
import request from '../../../utils/request_ajax';

/**
 * Add/Remove an item to/from `state.bulk.selected`; this will (check/uncheck)
 * an item on the front end
 * @param  {Number} Index of an item in `state.data.conent`
 */
export const bulkActionsToggleItem = index => ({
  type: BULK_ACTIONS.LIST.TOGGLE_ITEM,
  index,
});

/**
 * Add all items (indexes) to `state.bulk.selected`
 * @param  {Array} Indexes of items of `state.data.content`
 */
export const bulkActionsAddAll = indexes => ({
  type: BULK_ACTIONS.LIST.ADD_ALL,
  indexes,
});

/**
 * Remove all items (indexes) from `state.bulk.selected`
 */
export const bulkActionsRemoveAll = () => ({
  type: BULK_ACTIONS.LIST.REMOVE_ALL,
});

/**
 * Request a bulk action and set a timestamp for when the action is reuqested.
 * @param  {String} name Name of the action requested. It can be `archive` or
 * `tags`.
 * @returns {Object} Action dispatched including a timestamp for when the aciton
 * is requested.
 */
export const bulkActionsRequest = name => ({
  type: BULK_ACTIONS.SUBMIT.REQUEST,
  name,
  lastSubmitted: Date.now(),
});

/**
 * Announce that an action is done; this will hide the green success notifaction
 * @returns {Function|false} Thunk – Dispatcher for dataFetch only if needed
 */
export const bulkActionsSubmitDone = () => (dispatch, getState) => {
  const { data, bulk } = getState();

  dispatch({
    type: BULK_ACTIONS.SUBMIT.DONE,
  });

  /**
   * Empty the bulk list (which will result in unchecking all items)
   * @see bulkActionsRemoveAll
   */
  dispatch(bulkActionsRemoveAll());

  /**
   * Reload data for the current `state.filter.url` only if the view
   * hasn't changed by comparing timestamps for `state.data` and `state.bulk`
   * @see { dataFetch } form './index_data'
   */
  if (!data.lastFetched || data.lastFetched < bulk.lastSubmitted) {
    return dispatch(dataFetch(true));
  }

  return false;
};

/**
 * Announce that a bulk action was done successfully; this will show a success
 * notifaction by dispatching BULK_ACTION.SUBMIT.SUCCESS and hide after N
 * seconds by dispatching bulkActionsSubmitDone()
 * @see bulkActionsSubmitDone
 */
const bulkActionsSuccess = () => dispatch => {
  dispatch({
    type: BULK_ACTIONS.SUBMIT.SUCCESS,
  });

  setTimeout(() => {
    dispatch(bulkActionsSubmitDone());
  }, ui.NOTIFICATION_SUCCESS_DELAY);
};

/**
 * Announce that a bulk aciton failed complete (this will show UI warnings)
 * @return {Object} Action dispatch
 */
const bulkActionsFailure = () => ({
  type: BULK_ACTIONS.SUBMIT.FAILURE,
});

/**
 * Submit a bulk action via Ajax and handle the response.
 * @see bulkActionsRequest
 * @see bulkActionsSuccess
 * @see bulkActionsFailure
 * This functions takes an object {config} with 3 params.
 */
export const bulkActionsSubmit =
  ({ name, route, data }) =>
  (dispatch, getState) => {
    const state = getState();
    if (!state.bulk.inProgress) {
      dispatch(bulkActionsRequest(name));
      request
        .post(route, data)
        .done(() => {
          dispatch(bulkActionsSuccess());
        })
        .fail((xhr, textStatus, errorThrown) => {
          dispatch(bulkActionsFailure());
        });
    }
  };
